const ACTION_ITEMS = {
  TOPIC_CONTROLS: {
    TOPICS: {
      SET: 'TOPIC_CONTROLS_TOPICS_SET',
    },
  },
};

export default ACTION_ITEMS;
